import './App.css';
import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
} from 'react-router-dom';
import GameField from "./pages/table/GameField";
import LoginPage from "./components/LoginPage/LoginPage";
import MentorCabinet from "./components/mentorCabinet/MentorCabinet";
import './components/Variables.css'
import VerifyEmailPage from "./pages/verify_email";
import ForgotPassword from "./components/ForgotPassword";
import RestPassword from "./components/RestPassword";
import Registration from "./components/Registration";
import UserConditions from "./static_pages/user_conditions";
import ReferralProgramConditions from "./static_pages/referral_program_conditions";
import ConfidentialPolicy from "./static_pages/confidential_policy";

import AboutRecording from "./static_pages/about_recording";
import FiledStylesPreview from "./static_pages/field_styles";
import GroupGameContainer from "./components/GroupGame/GroupGameContainer";
import PaymentResult from "./components/mentorCabinet/PaymentResult";
import PaymentsPolicy from "./static_pages/payments_policy";
import PriceList from "./static_pages/price_list";
import GameComments from "./components/mentorCabinet/GameComments";
import GroupGameComments from "./components/mentorCabinet/GroupGameComments";
import ReactGA from 'react-ga4';
import Mentors from "./components/Mentors";
import * as Sentry from "@sentry/react";
import "./i18n";
import PriceList_en from "./static_pages/price_list_en";
import Payments_policy_en from "./static_pages/payments_policy_en";
import UserConditions_en from "./static_pages/user_conditions_en";
import Confidential_policy_en from "./static_pages/confidential_policy_en";
import ReferralProgramConditions_en from "./static_pages/referral_program_conditions_en";
import AboutRecording_en from "./static_pages/about_recording_en";
import StartPageNew2_en from "./components/StartPageNew2_en";
import StartPageNew2_ua from "./components/StartPageNew2_ua";
import FiledStylesPreview_en from "./static_pages/field_styles_en";

function App() {
    ReactGA.initialize('G-2W3TS6E710');

    const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

    return (
        <Router>
            <SentryRoutes>
                <Route path="/" element={<StartPageNew2_ua/>}/>
                <Route path="/en" element={<StartPageNew2_en/>}/>
                <Route path="/register" element={<Registration/>}/>
                <Route path="/login" element={<LoginPage/>}/>
                <Route path="/game/:id" element={<GameField/>}/>
                <Route path="/groupgame/:id" element={<GroupGameContainer/>}/>
                <Route path="/mentor/cabinet" element={<MentorCabinet/>}/>
                <Route path={"/verify_email"} element={<VerifyEmailPage/>}/>
                <Route path={"/forgot_password"} element={<ForgotPassword/>}/>
                <Route path={"/reset_password"} element={<RestPassword/>}/>
                <Route path={"/agreement"} element={<UserConditions/>}/>
                <Route path={"/agreement_en"} element={<UserConditions_en/>}/>
                <Route path={"/confidential_policy"} element={<ConfidentialPolicy/>}/>
                <Route path={"/confidential_policy_en"} element={<Confidential_policy_en/>}/>
                <Route path={"/referral_agreement"} element={<ReferralProgramConditions/>}/>
                <Route path={"/referral_agreement_en"} element={<ReferralProgramConditions_en/>}/>
                <Route path={"/about_recording"} element={<AboutRecording/>}/>
                <Route path={"/about_recording_en"} element={<AboutRecording_en/>}/>
                <Route path={"/about_payments"} element={<PaymentsPolicy/>}/>
                <Route path={"/about_payments_en"} element={<Payments_policy_en/>}/>
                <Route path={"/preview_field_styles"} element={<FiledStylesPreview/>}/>
                <Route path={"/preview_field_styles_en"} element={<FiledStylesPreview_en/>}/>
                <Route path={"/game_comments/:game_id"} element={<GameComments/>}/>
                <Route path={"/group_game_comments/:game_id/:player_id"} element={<GroupGameComments/>}/>
                <Route path={"/stripe_payment_return"} element={<PaymentResult/>}/>
                <Route path={"/price"} element={<PriceList/>}/>
                <Route path={"/price_en"} element={<PriceList_en/>}/>
                <Route path={"/mentors"} element={<Mentors/>}/>
            </SentryRoutes>
        </Router>
    );
}

export default App;
